var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCreditCard = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none",
    viewBox: "0 0 14 14",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#75777B",
    d: "M12.9508 5.0745V3.15c0-.5318-.4438-.9625-.9917-.9625H2.0425c-.548 0-.9917.4307-.9917.9625v1.9245z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#75777B",
    fillRule: "evenodd",
    d: "M1.0508 6.5188V10.85c0 .5318.4438.9625.9917.9625h9.9166c.5479 0 .9917-.4307.9917-.9625V6.5188zM6.5049 8.925a.4813.4813 0 0 1-.4812.4812H3.5154a.4813.4813 0 0 1 0-.9625h2.5083a.4813.4813 0 0 1 .4813.4813m3.9813.4812a.4812.4812 0 1 0 0-.9625H9.4654a.4813.4813 0 0 0 0 .9626z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCreditCard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/credit-card.7982ac641574b493654015b362539f70.svg";